import {
  CloudHail,
  Wrench,
  FileCheck,
  Sparkles,
  Truck,
  Layers,
  Bus,
  ArrowUpRight,
} from "lucide-react";

const services = [
  {
    num: "01",
    icon: CloudHail,
    title: "Débosselage sans peinture",
    tag: "DSP · Grêle",
    desc: "Réparation d'impacts de grêle et bosses légères sans retouche de peinture. Préservation intégrale de la peinture d'origine du constructeur.",
    big: true,
  },
  {
    num: "02",
    icon: Sparkles,
    title: "Smart Repair",
    tag: "Réparations locales",
    desc: "Rayures, éclats, petits chocs traités en zone restreinte. Gain de temps, coûts maîtrisés.",
  },
  {
    num: "03",
    icon: FileCheck,
    title: "Gestion de sinistres",
    tag: "Assurances",
    desc: "Prise en charge complète du dossier avec votre compagnie d'assurance, du chiffrage à la restitution.",
  },
  {
    num: "04",
    icon: Bus,
    title: "Utilitaires & Poids lourds",
    tag: "Camions · Semi · Camping-cars",
    desc: "Semi-remorques, camping-cars, fourgons (Renault Trafic, Master, Boxer...), camions et poids lourds. Interventions sur tous types d'utilitaires professionnels.",
    big: true,
  },
  {
    num: "05",
    icon: Layers,
    title: "Aluminium & Carbone",
    tag: "Spécialité carrosserie",
    desc: "Expertise avancée sur les carrosseries en aluminium et en carbone. Techniques adaptées aux matériaux haute technicité sans altération des propriétés structurelles.",
  },
  {
    num: "06",
    icon: Wrench,
    title: "Atelier mobile",
    tag: "Sur site",
    desc: "Intervention directement sur votre lieu de travail, concession ou flotte. Cabines mobiles équipées.",
  },
  {
    num: "07",
    icon: Truck,
    title: "Flottes & mobilité",
    tag: "B2B",
    desc: "Solutions sur-mesure pour flottes, loueurs et opérateurs logistiques : réparation express et véhicule de remplacement.",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#007AFF] mb-4">
              — Nos services
            </div>
            <h2
              data-testid="services-title"
              className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.95]"
            >
              Techniques artisanales<br />
              à <span className="text-[#007AFF]">grande échelle</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base text-white/60 leading-relaxed">
              De la petite bosse de parking au sinistre grêle massif, nous
              déployons une gamme complète de techniques de réparation
              artisanale au service des particuliers, des flottes et des
              professionnels.
            </p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <a
              href="#contact"
              key={i}
              data-testid={`service-card-${i}`}
              className={`group relative bg-[#111111] border border-white/5 hover:border-[#007AFF]/50 p-8 flex flex-col transition-all duration-500 hover:-translate-y-1 overflow-hidden ${
                s.big ? "md:col-span-2 lg:row-span-1" : ""
              }`}
            >
              <div className="flex items-start justify-between mb-8">
                <div className="text-xs font-mono text-white/30 tracking-widest">
                  / {s.num}
                </div>
                <ArrowUpRight className="w-5 h-5 text-white/30 group-hover:text-[#007AFF] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
              </div>

              <s.icon
                strokeWidth={1.25}
                className={`${s.big ? "w-16 h-16" : "w-12 h-12"} text-[#007AFF] mb-8`}
              />

              <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-2">
                {s.tag}
              </div>
              <h3
                className={`font-heading ${
                  s.big ? "text-3xl md:text-4xl" : "text-2xl"
                } font-bold uppercase tracking-tight mb-4 leading-tight`}
              >
                {s.title}
              </h3>
              <p className="text-sm text-white/60 leading-relaxed">{s.desc}</p>

              {/* Hover accent */}
              <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#007AFF] group-hover:w-full transition-all duration-500" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
